export default __webpack_public_path__ + "static/media/Vadim.fcc12ea9.mp4";